import { forwardRef } from 'react';
import { DialogButton } from '~/components/ui/Dialog';

interface Props {
  className?: string;
}

const SurveyStepFinal = forwardRef<HTMLDivElement, Props>(({ className }, ref) => (
  <div className={className} ref={ref}>
    <span className="i-heroicons:gift size-16 mb-10" />

    <h2 className="text-[32px]/[39px] font-semibold">Your reward is here!</h2>

    <p className="text-bolt-ds-textSecondary mt-4 px-6">
      <strong className="text-bolt-ds-textPrimary">1M extra tokens</strong> were added to your account! <br />
      Now enjoy building apps like never before.
    </p>

    <div className="mt-8 flex items-center gap-3">
      <DialogButton type="submit" variant="primary">
        Let’s build apps!
      </DialogButton>
    </div>
  </div>
));

SurveyStepFinal.displayName = 'SurveyStepFinal';

export default SurveyStepFinal;
